import type { OfferCampaignCoupon } from '../types/offer-campaigns';
import { OfferVisualIcon } from './OfferVisualIcon';
import { formatOfferCampaignDate, formatOfferCampaignDateTime } from './OfferCampaignDateField';

export function OfferCouponCard({ coupon }: { coupon: OfferCampaignCoupon }) {
  const payment = coupon.verifiedPayment || {};
  return (
    <>
      <OfferVisualIcon name="trophy" />
      <OfferVisualIcon name="check" />
      <span>Enrollment Completed</span>
      <h3>{coupon.offerCode}</h3>
      <p>{coupon.patientName || '-'} | {coupon.mrn} | {coupon.centerName || '-'}</p>
      <strong>{currency(coupon.discountAmount)} discount confirmed</strong>
      {payment.packagePlan && <div className="offer-coupon-payment-summary">
        <span>Plan: {String(payment.packagePlan)}</span>
        <span>Package: {formatOfferCampaignDate(payment.packageStartDate)} to {formatOfferCampaignDate(payment.packageEndDate)}</span>
        <span>Advance: {currency(Number(payment.paymentAmount))} · Due: {currency(Number(payment.totalAmountDue))}</span>
        {Boolean(payment.paymentMode) && <span>Payment: {String(payment.paymentMode)}{payment.cardType ? ` · ${String(payment.cardType)}` : ''}{payment.paymentReference ? ` · Ref: ${String(payment.paymentReference)}` : ''}</span>}
      </div>}
      <small>Completed at {formatDateTime(coupon.completedAt)}</small>
    </>
  );
}

function currency(value: number | null | undefined) {
  if (typeof value !== 'number' || !Number.isFinite(value)) return '-';
  return new Intl.NumberFormat('en-IN', { style: 'currency', currency: 'INR', maximumFractionDigits: 0 }).format(value);
}

function formatDateTime(value: string | null | undefined) {
  return formatOfferCampaignDateTime(value);
}
